import { lazy } from 'react';
import { type RouteObject } from 'react-router-dom';

import { EUserSource } from '@cuemath/leap';

import { AUTH_ROUTES as AUTH_ROUTE_CONSTANTS } from '../route-constants';
import AuthRoutesWrapper from '../wrappers/auth-routes-wrapper';

const LoginPage = lazy(() => import('@~/pages/login-v2/login'));
const ForgotPasswordPage = lazy(() => import('@~/pages/forgot-password/forgot-password'));
const SignupUnavailable = lazy(
  () => import('@~/pages/signup-unavailable/signup-unavailable'),
);
const GiftInvitePage = lazy(() => import('@~/pages/gift-invite/gift-invite'));
const NoDevicePage = lazy(() => import('@~/pages/no-device/no-device'));
const SignupPage = lazy(() => import('@~/pages/signup/signup'));

export const AUTH_ROUTES: RouteObject = {
  element: <AuthRoutesWrapper />,
  children: [
    {
      path: AUTH_ROUTE_CONSTANTS.LOGIN.PATH,
      element: <LoginPage />,
      handle: {
        pageName: AUTH_ROUTE_CONSTANTS.LOGIN.NAME,
      },
    },
    {
      path: AUTH_ROUTE_CONSTANTS.FORGOT_PASSWORD.PATH,
      element: <ForgotPasswordPage />,
      handle: {
        pageName: AUTH_ROUTE_CONSTANTS.FORGOT_PASSWORD.NAME,
      },
    },
    {
      path: AUTH_ROUTE_CONSTANTS.SIGNUP_UNAVAILABLE.PATH,
      element: <SignupUnavailable />,
      handle: {
        pageName: AUTH_ROUTE_CONSTANTS.SIGNUP_UNAVAILABLE.NAME,
      },
    },
    {
      path: AUTH_ROUTE_CONSTANTS.SIGNUP_LP.PATH,
      element: <SignupPage userSource={EUserSource.PLA} />,
      handle: {
        pageName: AUTH_ROUTE_CONSTANTS.SIGNUP_LP.NAME,
      },
    },
    {
      path: AUTH_ROUTE_CONSTANTS.SIGNUP_BAU.PATH,
      element: <SignupPage userSource={EUserSource.LEAP_BAU} />,
      handle: {
        pageName: AUTH_ROUTE_CONSTANTS.SIGNUP_BAU.NAME,
      },
    },
    {
      path: AUTH_ROUTE_CONSTANTS.CHANNEL_LP.PATH,
      element: <SignupPage userSource={EUserSource.PLA} />,
      handle: {
        pageName: AUTH_ROUTE_CONSTANTS.CHANNEL_LP.NAME,
      },
    },
    {
      path: AUTH_ROUTE_CONSTANTS.CHANNEL_BAU.PATH,
      element: <SignupPage userSource={EUserSource.LEAP_BAU} />,
      handle: {
        pageName: AUTH_ROUTE_CONSTANTS.CHANNEL_BAU.NAME,
      },
    },
    {
      path: AUTH_ROUTE_CONSTANTS.GIFT_INVITE.PATH,
      element: <GiftInvitePage />,
      handle: {
        pageName: AUTH_ROUTE_CONSTANTS.GIFT_INVITE.NAME,
      },
    },
    {
      path: AUTH_ROUTE_CONSTANTS.NO_DEVICE.PATH,
      element: <NoDevicePage />,
      handle: {
        pageName: AUTH_ROUTE_CONSTANTS.NO_DEVICE.NAME,
      },
    },
  ],
};
